import script from "./CompareChartView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareChartView.vue?vue&type=script&setup=true&lang=js"

import "./CompareChartView.vue?vue&type=style&index=0&id=cb2a12a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb2a12a2"]])

export default __exports__